<template>
    <v-dialog v-model="show_select_e_inv_popup" persistent max-width="800" class="rounded-xl ma-0">
        <v-card >
            <v-card-title class="text-h5 sector-head py-5">
                Mis Datos / Factura Electrónica
            </v-card-title>
            <v-card-text class="pa-0 ma-0">
                <template>
                    <v-row cols="12" class="ma-0 d-flex align-center">
                        <v-col cols="3" class="pl-4 d-flex align-center">
                          <p class="mb-0">
                            Créditos activos
                            <span class="pa-2 rounded-md bg-credits font-weight-bold">
                              {{ this.screen_data_2.sd.companies.length }}/{{ this.screen_data_2.sd.credits }}
                            </span>
                          </p>
                        </v-col>
                      
                        <v-col cols="8" class="ma-0">
                          <v-text-field
                            append-icon="mdi-magnify"
                            v-model="search"
                            label="Buscar"
                            hide-details
                            class="pa-0 ma-0 rounded-pill"
                          />
                        </v-col>
                      </v-row>
                    <v-row class="d-flex justify-between ma-0">
                        <v-col class="d-flex align-center pl-4" cols="5">
                            <p class="mb-0 mr-2">{{ start }} - {{ end }} de {{ this.screen_data_2.companies.length }}</p>
                            <v-btn icon @click="prevPage" :disabled="currentPage === 1">
                                <v-icon>mdi-chevron-left</v-icon>
                            </v-btn>
                            <v-btn icon @click="nextPage" :disabled="!hasNextPage">
                                <v-icon>mdi-chevron-right</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col class="d-flex align-center justify-end" cols="6">
                            <span class="mr-3">Filtro</span>
                            <div class="filter-custom">
                                <v-btn 
                                    icon 
                                    @click="toggleFilter('checked')"
                                    :class="{ 'v-btn--active': filterType === 'checked' }"
                                    class="item-filter" 
                                >
                                    <v-icon>mdi-checkbox-marked</v-icon>
                                </v-btn>
                                <v-btn
                                    icon
                                    @click="toggleFilter('unchecked')"
                                    :class="{ 'v-btn--active': filterType === 'unchecked' }"
                                    class="item-filter"
                                >
                                    <v-icon>mdi-checkbox-blank-outline</v-icon>
                                </v-btn>
                            </div>
                        </v-col>
                    </v-row>
                    <v-divider class="pa-0"/>
                    <v-row class="ma-0">
                        <v-col
                            v-for="(group, groupIndex) in paginatedCompanies"
                            :key="'column-' + groupIndex"
                            class="ma-0 pl-4"
                            cols="6"
                        >
                            <v-row v-for="company in group" :key="company.id">
                                <v-col class="py-0 ma-0">
                                    <v-checkbox
                                        :label="company.name"
                                        :input-value="isSelected(company)"
                                        :disabled="isDisabled(company.id)"
                                        @change="toggleSelection(company)"
                                        hide-details
                                        :class="{'disabled-checkbox': isDisabled(company.id)}"
                                        class="py-0 mx-0"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-divider class="mx-0 w-100" />
                </template>
            </v-card-text>
            <v-card-actions class="py-8 mx-0 d-flex justify-center">
                <app-btn 
                    v-for="(action, index) in actions" 
                    v-bind:key="index" 
                    large 
                    outlined
                    @click="doEmit(action['emit'])" :color="action['primary'] ? 'white justify-start' : 'primary'"
                    :class="action['primary'] ? 'primary-background justify-end ml-10' : 'primary-border'"
                    class="rounded-pill"
                >
                    {{ action['action_text'] }}
                </app-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import AppBtn from '@/components/layout/AppBtn.vue'
import { selectInput } from 'aws-amplify';

export default {
    name: 'SelectEInvContractPopup',

    components: {
        AppBtn,
    },

    props: {
        show_select_e_inv_popup: {
            type: Boolean,
            required: true
        },
        screen_data_2: {
            type: Object,
            required: true
        },
        persistent: {
            type: Boolean,
            required: false,
            default: true,
        },
        actions: {
            type: Array,
            required: false,
            default: function () {
                return [
                    { 'action_text': 'Cancelar', 'emit': 'close-message-without-companies', 'prin': true, 'primary': false },
                    { 'action_text': 'Confirmar', 'emit': 'close-message', 'prin': true, 'primary': true },
                ];
            }
        },
    },
    data() {
        return {
            selected_companies: [],
            currentPage: 1,
            itemsPerPage: 20,
            companiesPerColumn: 10,
            search: '',
            filterType: "",
        }
    },
    created() {
        // Marca las empresas que estan en el sd
        this.selected_companies = this.screen_data_2.companies.filter((item) =>
            this.screen_data_2.sd.companies.some((preItem) => preItem.id === item.id) 
        );
    },
    computed: {
        start() {
            return (this.currentPage - 1) * this.itemsPerPage + 1;
        },
        end() {
            return Math.min(this.currentPage * this.itemsPerPage, this.screen_data_2.companies.length);
        },
        filteredCompanies() {
            let filteredCompanies = this.screen_data_2.companies;

            if (this.filterType === "checked") {
                filteredCompanies = filteredCompanies.filter((company) =>
                    this.isDisabled(company.id)
                );
            } else if (this.filterType === "unchecked") {
                filteredCompanies = filteredCompanies.filter(
                    (company) => !this.isDisabled(company.id)
                );
            } else {
                filteredCompanies = this.screen_data_2.companies.filter((company) =>
                    company.name && company.name.toLowerCase().includes(this.search ? this.search.toLowerCase() : '')
                );
            }

            return filteredCompanies;
        },
        paginatedCompanies() {
            
            const sortedCompanies = this.filteredCompanies.sort((a, b) => 
                (a.name || '').localeCompare(b.name || '')
            );
            const start = (this.currentPage - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            const companiesOnPage = sortedCompanies.slice(start, end);
            const columns = [];

            for (let i = 0; i < companiesOnPage.length; i += this.companiesPerColumn) {
                columns.push(companiesOnPage.slice(i, i + this.companiesPerColumn));
            }

            return columns;
        },
        hasNextPage() {
            return (
                this.currentPage * this.itemsPerPage <
                this.screen_data_2.companies.length
            );
        },
    },
    methods: {
        doEmit(emit) {
            let limit_credits = this.screen_data_2.sd.credits >= this.selected_companies.length
            if (emit == 'close-message-without-companies') {
                this.$emit('close-message', '', true);
            } else {
                this.$emit(emit, this.selected_companies, limit_credits);
            }
        },
        nextPage() {
            if (this.hasNextPage) {
                this.currentPage++;
        }
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
            }
        },
        isSelected(item) {
            if(this.selected_companies.some((selected) => selected.id === item.id))
                return true
            return false
        },
        toggleSelection(item) {
            if (this.isSelected(item)) {
                this.selected_companies = this.selected_companies.filter(
                    (selected) => selected.id !== item.id
                );
            } else {
                this.selected_companies.push(item);
            }
        },
        isDisabled(id) {
            return this.screen_data_2.sd.companies.some(disabledItem => disabledItem.id === id);
        },
        toggleFilter(type) {
            this.filterType = this.filterType === type ? null : type;
        },
    }
}
</script>

<style lang="scss" scoped>
.primary-background {
    background-color: var(--v-primary-base);
}

.sector-head {
    background-color: #f9f6fe;
    color: var(--v-primaryDark-base);
}

.bg-credits {
    color: #512a79;
    background-color: var(--v-primaryLighter-base);
}

.primary-border {
    border-color: var(--v-primary-base) !important;
}

.table-head {
    border-left-style: solid;
    border-right-style: solid;
    border-color: #D9D9D9;
    border-width: thin;
}

.app-confirm-modal__body,
.app-confirm-modal__question {
    font-family: 'Roboto';
    font-style: normal;
    font-size: 20px;
    line-height: 23px;
    text-transform: none;
    letter-spacing: normal;
    font-weight: bold;
}

.v-input--checkbox::v-deep {
    .v-icon {
        color: #512a79;
    }
}

.app-confirm-modal__body {
    font-weight: 400;
}

.filter-custom {
    border-radius: 8px;
    background: rgba(217, 217, 217, 0.50); 
    font-weight: bold;
    align-items: center;
}
.filter-custom .item-filter {
    border-radius: 4px;
    padding: 5px;
    margin-left: 6px;
    margin-right: auto;
}
.filter-custom .item-filter.v-btn--active {       
    background: #565656;
    color: white;
}

</style>

<style>
.disabled-checkbox.theme--light.v-input--selection-controls.v-input--is-disabled:not(.v-input--indeterminate) .v-icon {
    color: var(--v-primaryLighter-base) !important;
}
</style>